import {
  GET_DRUSTVO,
  GET_OSOBA,
  PURGE_UPDATE,
} from "../../constants/constants";

const initialState = {
  idDrustva: "",
  vrDrustva: "",
  idOsobe: "",
  vrOsobe: "",
  oznDokumenta: "",
  error: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_DRUSTVO:
      return {
        ...state,
        idDrustva: action.idDrustva,
        vrDrustva: action.vrDrustva,
        idOsobe: "",
        vrOsobe: "",
        oznDokumenta: action.oznDokumenta || "",
        error: false,
      };
    case GET_OSOBA:
      return {
        ...state,
        idDrustva: "",
        idOsobe: "",
        idOsobe: action.idOsobe,
        vrOsobe: action.vrOsobe,
        oznDokumenta: action.oznDokumenta || "",
        error: false,
      };
    case PURGE_UPDATE:
      return {
        ...initialState,
      };
    default: {
      return state;
    }
  }
};
